'use strict';

(function () {
	angular.module('onboarding.common')
		.directive('cobConfirmCompany', cobConfirmCompany);

	cobConfirmCompany.$inject = [
		'$log', '$timeout', '$state', 'subjectObserverMessagesService', 'observerService', 'sessionService',
		'carrierRegistrationService'
	];

	var $log,
		$timeout,
		$state,
		subjectObserverMessagesService,
		observerService,
		sessionService,
		subjectMessages,
		observerMessages,
		carrierRegistrationService;

	function cobConfirmCompany(_$log_,
		_$timeout_,
		_$state_,
		_subjectObserverMessagesService_,
		_observerService_,
		_sessionService_,
		_carrierRegistrationService_) {
		$log = _$log_;
		$timeout = _$timeout_;
		$state = _$state_;
		subjectObserverMessagesService = _subjectObserverMessagesService_;
		observerService = _observerService_;
		sessionService = _sessionService_;
		carrierRegistrationService = _carrierRegistrationService_;

		return {
			restrict: 'E',
			scope: {
				visible: '=',
				carrierList: '=',
				numberText: '=',
				searchNumber: '='
			},
			replace: true,
			templateUrl: '/app/common/welcome/confirmCompany.html',
			link: linkFunction
		};
	}

	function linkFunction(scope) {

		activate();

		function activate() {
			subjectMessages = subjectObserverMessagesService.getSubjectMessages();
			observerMessages = subjectObserverMessagesService.getObserverMessages();

			scope.m = {
				carrier: {},
				errorMessage: ''
			};

			scope.carriers = {};
			scope.displayCarriers = [];

			scope.setActiveSlide = setActiveSlide;
			scope.submitClick = submitClick;

			registerObserverHandlers();

			scope.$watch('carrierList', parseCarrierList);
		}

		function parseCarrierList(newList, oldList) {
			scope.displayCarriers = [];
			scope.carriers = {};

			if (!newList)
				return;

			var dot = '';
			for (var i = 0; i < newList.length; i++) {
				dot = newList[i].dotNumber.toString();
				if (scope.carriers[dot]) {
					scope.carriers[dot].push(newList[i]);
				}
				else {
					scope.carriers[dot] = [(newList[i])];
					scope.displayCarriers.push(newList[i]);
				}
			}
		}

		function registerObserverHandlers() {
		}

		function setActiveSlide(slide) {
			scope.m.errorMessage = '';
			scope.m.carrier = {},
			observerService.sendMessageToSubject(scope,
				subjectObserverMessagesService.getSubjectMessages().COB_SUBJECT_CHANGE_WELCOME_VIEW,
				{
					setActiveSlide: slide
				});
		}

		function submitClick() {
			if (scope.displayCarriers.length === 1) {
				scope.m.carrier = scope.displayCarriers[0];
			}
			if (!scope.m.carrier) {
				scope.m.errorMessage = 'You must choose from the list to continue.';

				return;
			}

			if (scope.carriers[scope.m.carrier.dotNumber].length > 1) {
				observerService.sendMessageToSubject(scope,
					subjectObserverMessagesService.getSubjectMessages()
						.COB_SUBJECT_CHANGE_WELCOME_VIEW,
					{
						setActiveSlide: 'multipleCarriersSection',
						carrierList: scope.carriers[scope.m.carrier.dotNumber],
						modalMessage: '',
						modalTitle: ''
					});

				return;
			}
			else {
				scope.m.errorMessage = '';

				carrierRegistrationService.setCarrier(scope.carriers[scope.m.carrier.dotNumber][0]);
				$state.transitionTo('registration');
			}

		}
	}

})();
